import { Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect } from 'react';
import { trackPromise } from 'react-promise-tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { onError, onSuccess } from 'src/store/actions/popupActions';
import { INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED, INTERNAL_BILATERAL_CONTRACT_RETRIEVED } from 'src/store/InternalBilateral/InternalBilateralActionTypes';
import useStyles from "src/Styles";
import axios from '../../../axios/AxiosInterceptors';
import ContractDetails from '../Contracts/ContractDetails';
import CreateScheduleComponent from "./CreateScheduleComponent";


const CreateSchedule = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const params = useParams();
    const selectedContract = useSelector(state => state.internalBilateral.selectedContract);
    const contractResults = useSelector(state => state.internalBilateral.contractResults);

    useEffect(() => {
        retrieveContracts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params])

    const retrieveContracts = async () => {
        let urlParams = { pageSize: 100, pageNumber: 0, orderBy: "contractName", direction: "asc" };
        await trackPromise(axios.get("/inschedule/v2/account/" + params.accountId + "/contract", { params: urlParams }).then(response => {
            dispatch({ type: INTERNAL_BILATERAL_CONTRACT_RESULTS_RETRIEVED, contractResults: response.data });
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    const saveSchedules = async (schedules) => {
        await trackPromise(axios.post("/inschedule/v2/account/" + params.accountId + "/contract/" + selectedContract.id + "/schedule", JSON.stringify(schedules)).then(response => {
            dispatch(onSuccess("Successfully created schedules"));
        }).catch(error => {
            dispatch(onError(error.response));
        }));
    }

    return (
        <main className={classes.layout}>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4}>
                    <Autocomplete value={selectedContract} options={[{ contractName: '', contractId: 0 }, ...contractResults.results]}
                        getOptionLabel={(option) => (option && option.contractName) ? option.contractName : ''}
                        getOptionSelected={(option, value) => option.contractId === value.contractId}
                        renderInput={(params) => <TextField {...params} label="Contract Name" />}
                        onChange={(event, value) => dispatch({ type: INTERNAL_BILATERAL_CONTRACT_RETRIEVED, selectedContract: value })} />
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
            <ContractDetails />
            <CreateScheduleComponent onSave={saveSchedules} />
        </main>
    )
}

export default CreateSchedule;